module.exports = __webpack_public_path__ + "img/home-2.4a3cce10.png";